import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../EnvImpairment/envImpairment.module.scss'
import metadata from './CoveredLocationsDetailsComponent.metadata.json5';

import NatureOfOperationsComponent from '../subcomponents/NatureOfOperations/NatureOfOperationsComponent';
import LocationsOccupiedComponent from '../subcomponents/LocationsOccupied/LocationsOccupiedComponent'
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function CoveredLocationsDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('CoveredLocationsDetailsComponent');

    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifOthPleExp27: {
            visible: !_.isUndefined(modelVM.value.oth26) && modelVM.value.oth26
        },
        NatureOfOperationsComponent: {
            data: modelVM.natureofOperations,
            updateWizardData,
            submissionVM,
            CompanyContractDetailsPath: `${pathUpdated}.natureofOperations` 
        },
        LocationsOccupiedComponent: {
            data: modelVM.locationsOccupied,
            updateWizardData,
            submissionVM,
            CompanyContractDetailsPath: `${pathUpdated}.locationsOccupied` 
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            NatureOfOperationsComponent,
            LocationsOccupiedComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

CoveredLocationsDetailsComponent.propTypes = wizardProps;
export default withRouter(CoveredLocationsDetailsComponent);
